import React from 'react';
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import { BASE_URL } from '../config/urls';

export default function UploadsTable({ files }) {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    const classes = useStyles();
    function downloadFile(address) {
        fetch(BASE_URL + "/" + decodeURI(address), { headers:{Authorization:'Bearer '+localStorage.getItem('token')} })
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.download = 'device-list.xlsx';
                anchor.click();
                window.URL.revokeObjectURL(objectUrl);
            });
    }
    return (
        <Paper variant="outlined" className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {files.map((row) => {
                            return (
                                <TableRow hover tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        const isId = column.id === 'fileAddress';
                                        return (
                                            <TableCell key={column.id} component={isId && Link}
                                                to={isId && value} align={column.align}>
                                                {isId ? (<div onClick={() => downloadFile(value)}>دانلود</div>) : column.format ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>

    );
}


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});


const columns = [
    {
        id: 'createdAt', label: 'تاریخ',
        minWidth: 170,
        format: (value) => new Intl.DateTimeFormat('fa-IR', { dateStyle: 'medium', timeStyle: 'medium' }).format(new Date(value)),
    },
    { id: 'creator', label: 'فرستنده', minWidth: 100, format: user => user?.name ?? '' },
    {
        id: 'success', label: 'موفقیت', minWidth: 100,
        format: (value) => value ? 'موفق' : 'اشکال',
    },
    { id: 'fileAddress', label: 'دانلود فایل', minWidth: 120 },
];
